module.exports = {
  ACTIVITY_TYPE_MARKETPLACE_APP_VIEW: "Viewed App in Marketplace",
  ACTIVITY_TYPE_MARKETPLACE_APP_INSTALL: "Installed App in Marketplace",
  ACTIVITY_TYPE_MARKETPLACE_APP_DOWNLOAD: "Downloaded App in Marketplace",
  ACTIVITY_TYPE_MARKETPLACE_APP_CONTACT: "Clicked App Contact in Marketplace"
};
